import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Layout from '@/components/Layout';
import { Card, CardContent } from '@/components/ui/card';
import { Bell, Pin, Calendar } from 'lucide-react';

import { BACKEND_URL } from '../../config/api';
const API = `${BACKEND_URL}/api`;

const getAuthHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('lms_token')}`
});

export default function Announcements({ user, onLogout }) {
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAnnouncements();
  }, []);

  const fetchAnnouncements = async () => {
    try {
      const res = await axios.get(`${API}/announcements`, { headers: getAuthHeaders() });
      setAnnouncements(res.data);
    } catch (error) {
      console.error('Failed to fetch announcements:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <Layout user={user} onLogout={onLogout} currentPage="announcements"><div className="p-8">Loading...</div></Layout>;
  }

  return (
    <Layout user={user} onLogout={onLogout} currentPage="announcements">
      <div className="p-6 lg:p-8 space-y-6">
        <div>
          <h1 className="text-3xl font-bold text-navy">Announcements</h1>
          <p className="text-[#4D4D4D] mt-2 font-light">Stay updated with latest news and updates</p>
        </div>

        {announcements.length === 0 ? (
          <Card className="border-0 card-shadow bg-white rounded-2xl">
            <CardContent className="p-16 text-center">
              <Bell className="w-20 h-20 mx-auto mb-4 text-[#E7E7E7]" strokeWidth={1.5} />
              <h3 className="text-xl font-bold text-navy mb-2">No Announcements</h3>
              <p className="text-[#4D4D4D] font-light">Check back later for updates</p>
            </CardContent>
          </Card>
        ) : (
          <div className="space-y-4">
            {announcements.map((announcement, index) => (
              <Card key={announcement.id} className="border-0 card-shadow card-hover transition-smooth bg-white rounded-2xl">
                <CardContent className="p-6">
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 rounded-xl premium-gradient flex items-center justify-center flex-shrink-0">
                      {index < 3 ? (
                        <Pin className="w-6 h-6 text-white" strokeWidth={2} />
                      ) : (
                        <Bell className="w-6 h-6 text-white" strokeWidth={2} />
                      )}
                    </div>
                    <div className="flex-1">
                      <div className="flex items-start justify-between mb-2">
                        <h3 className="text-lg font-bold text-navy">{announcement.title}</h3>
                        {index < 3 && (
                          <span className="px-3 py-1 bg-primary-blue text-white text-xs font-semibold rounded-full">Important</span>
                        )}
                      </div>
                      <p className="text-[#4D4D4D] mb-3 font-light">{announcement.content}</p>
                      <div className="flex items-center space-x-2 text-sm text-[#A5A5A5]">
                        <Calendar className="w-4 h-4" strokeWidth={2} />
                        <span>{new Date(announcement.created_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}</span>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
}